import { createStore } from '@stencil/store';

import type { Content, Screen, ScreenContext, Mode, Layout, CustomFieldError, MiniOverlayConfig } from './types';
import type { HighlightableElement } from './components/clickable-element';
import type { DropdownOption } from './components/dropdown/dropdown-input';

export type State = {
  mode: Mode;
  account: string;
  overlayId: string;
  content: Content;
  layout: Layout | Record<string, never>;
  preventHighlight: boolean;
  currentScreen: ScreenContext;
  isMobileViewport: boolean;
  highlightElement: HighlightableElement | null;
  openDropdown: {
    id: string;
    options: DropdownOption[];
    onOptionSelect: (option: DropdownOption) => void;
    style?: { [key: string]: string };
  } | null;
  dropdownContainerRefs: Record<string, HTMLElement>;
  currentScreenContainer: HTMLElement;
  shadowRoot: ShadowRoot;

  // Mini overlay feature state
  showMiniOverlay: boolean;
  miniOverlayConfig: MiniOverlayConfig | null;
  shouldShowMiniOverlayFirst: boolean;

  emailValue?: string;
  nextScreen?: Screen;
  customFieldErrorMsg?: CustomFieldError;
  showErrors?: boolean;

  usersCountryRequiresOpenTrackingConsent?: boolean;
};

const { state, on, ...rest } = createStore<State>(() => ({
  mode: 'live',
  content: null,
  layout: { name: 'default' },
  account: null,
  overlayId: null,
  preventHighlight: false,
  currentScreen: 'email',
  isMobileViewport: false,
  highlightElement: null,
  openDropdown: null,
  dropdownContainerRefs: {},
  currentScreenContainer: null,
  shadowRoot: null,
  // Mini overlay feature state
  showMiniOverlay: false,
  miniOverlayConfig: null,
  shouldShowMiniOverlayFirst: false,
}));

export default state;
export const store = { on, ...rest };
